import type { BadgeResponse } from '@/app/commons/generated'
import { getDuprApi } from '@/app/commons/network/duprApiCore'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import { useQuery } from '@tanstack/react-query'

/** Shared query key for the logged-in user's own badge list. */
export const myBadgesQueryKey = ['badges', 'me'] as const

/**
 * The logged-in user's public badges from `GET /badges`. Player payloads carry
 * badges for *other* players; the redux `User` object does not, so own-profile
 * surfaces (e.g. the dashboard header) read them from here instead. Undefined
 * while loading or logged out.
 */
export function useMyBadges(enabled = true): BadgeResponse[] | undefined {
  const { token } = useAppSelector(authSelector)
  const { data } = useQuery({
    queryKey: myBadgesQueryKey,
    queryFn: async () => {
      const res = await getDuprApi().badges.getMyBadges()
      return res.data
    },
    // Badges change rarely (server-granted); a long stale window is fine.
    staleTime: 5 * 60_000,
    enabled: enabled && !!token,
  })
  return data
}
